import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { ensureHttpsPrefix } from "../../utils";

interface OpenInNewTabProps {
    url?: string | null;
    onOpen?: (url: string) => void;
    "data-automation"?: string;
    ref?: React.RefObject<HTMLButtonElement>;
}

export const OpenInNewTab = ({ url, onOpen, "data-automation": dataAutomation, ref }: OpenInNewTabProps) => {
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();

        if (!url) {
            return;
        }

        onOpen?.(url);
        window.open(ensureHttpsPrefix(url), "_blank", "noopener,noreferrer");
    };

    return (
        <Box flexShrink={0}>
            <IconButton
                iconName="link-out"
                type="flat"
                iconSize="xs"
                iconColor={colorsPalettes.blue[400]}
                ref={ref}
                onClick={handleClick}
                isDisabled={!url}
                data-automation={dataAutomation}
            />
        </Box>
    );
};
